module.exports = __webpack_public_path__ + "img/index.9c4f8983.jpg";